import React, { useState } from "react"

import { type ToolbarItem } from "@coval/ui"
import { Tag } from "lucide-react"

import { CollectionFilter } from "@/components/filters/CollectionFilter"
import { EditableFilterChip } from "@/components/filters/EditableFilterChip"
import type { CollectionFilterControls } from "@/hooks/useCollectionFilters"

import { TagPicker } from "./TagPicker"

interface TagFilterControlProps {
  filters?: CollectionFilterControls
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  onSelectedTagsChange: (tags: string[]) => void
  selectedTags: string[]
}

export const TagFilterControl: React.FC<TagFilterControlProps> = ({
  filters,
  isOpen,
  onOpenChange,
  onSelectedTagsChange,
  selectedTags,
}) => {
  const [section, setSection] = useState<string | null>(null)
  return (
    <div className="flex flex-wrap items-center gap-2">
      <CollectionFilter
        label="Filter"
        controls={
          filters ?? {
            properties: [],
            values: {},
            onChange: () => {},
            reset: () => {},
            activeCount: 0,
          }
        }
        open={isOpen}
        onOpenChange={onOpenChange}
        section={section}
        onSectionChange={setSection}
        activeCount={selectedTags.length}
        onReset={() => onSelectedTagsChange([])}
        items={[
          {
            id: "tags",
            label: "Tag",
            icon: <Tag />,
            activeCount: selectedTags.length,
            content: (
              <TagPicker
                selectedTags={selectedTags}
                onSelectedTagsChange={onSelectedTagsChange}
                isOpen
                onOpenChange={() => {}}
                trigger={<span />}
              />
            ),
          },
        ]}
      >
        {selectedTags.length > 0 && (
          <EditableFilterChip
            property="Tag"
            value={selectedTags.join(", ")}
            onEdit={() => {
              setSection("tags")
              onOpenChange(true)
            }}
            onRemove={() => onSelectedTagsChange([])}
          />
        )}
      </CollectionFilter>
    </div>
  )
}

/** Shared property picker and editable tag chip for resource table toolbars. */
export function createTagFilterToolbarItem(
  props: TagFilterControlProps,
): ToolbarItem {
  const measurement = (
    <TagFilterControl {...props} isOpen={false} onOpenChange={() => {}} />
  )
  return {
    type: "custom",
    id: "tags",
    full: <TagFilterControl {...props} />,
    compact: <TagFilterControl {...props} />,
    measureFull: measurement,
    measureCompact: measurement,
  }
}
